import type { tGeoPoint } from "./geo";
import { tTaskCustomField } from "./tasks";

export enum eBizClientDomain {
  MASTER = "master",
  SALOON = "saloon",
}

export type tClientBucket = "new" | "no_orders" | "regular" | "lost" | "remind";

export type tBizClientTasksStats = {
  last_task_date?: string;
  tasks_count: number;
  cancelled_tasks_count: number;
  completed_tasks_count: number;
  tasks_income?: number;
};

export type tClientsConfig = {
  stale_days_to_become_lost: number;
  stale_days_to_become_pre_lost: number;
  tasks_to_become_regular: number;
};

export type tBizClient = {
  _id: any;
  user?: string;
  first_name: string;
  last_name?: string;
  full_name: string;
  avatar?: string;
  sex: boolean;
  bucket?: tClientBucket;
  phone?: string;
  banned?: boolean;
  email?: string;
  insta_id?: string;
  source?: string;
  vk_id?: string;
  tg_id?: string;
  master?: string;
  saloon?: string;
  birthdate?: string;
  location?: Maybe<tGeoPoint>;
  location_hr?: string;
  comment?: string;
  domain: eBizClientDomain;
  bday_notify?: string;
  timezone: string;
  locale: string;
  stats: tBizClientTasksStats;
  custom_fields?: tTaskCustomField[];
  board_income?: number;
};

export type tCreateBizClientArgs = Omit<
  tBizClient,
  "stats" | "user" | "full_name" | "_id"
> & {
  board?: string;
  board_list?: string;
};
export type tUpdateBizClientArgs = Partial<
  Omit<
    tBizClient,
    "user" | "master" | "saloon" | "domain" | "stats" | "full_name" | "_id"
  >
>;

export type tRefreshClientBucketsArgs = {
  master?: string;
  saloon?: string;
  should_notify_client_on_bucket_change?: boolean;
};

export type tGetClientTasksHistoryArgs = {
  /*
   * iso date
   */
  last?: string;
  limit?: number;
};
